export function headerMenuAndSticky() {
    const body = $("body");
    const $header = $(".header");
    const $mainNav = $(".main-navigation");
    const $headerMenuOpener = $header.find(".mobile-menu-opener");
    let menuDrop = $mainNav.find(".menu-item-has-children");
    let menuItemFirstLevel = $mainNav.find(".main-navigation-list > .menu-item-has-children");

    menuDrop.each(function () {
        $(this).find(">a").after("<button class='header-mobile-menu-opener'><svg width=\"10\" height=\"6\" viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 1L5 5L9 1\" stroke=\"white\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></button>");
    });

    $headerMenuOpener.on("click", function () {
        if (body.hasClass("main-menu-opened")) {
            body.removeClass("main-menu-opened");
        } else {
            body.addClass("main-menu-opened");
        }
    });

    $('.overlay-main-navigation-holder').on("click", function (event) {
        body.removeClass("main-menu-opened");
    });

    body.on("click", ".header-mobile-menu-opener", function () {
        let $parent = $(this).parent(".menu-item-has-children");
        if (window.innerWidth < 1200 || body.hasClass("touch")) {
            if ($parent.hasClass("active")) {
                $parent.removeClass("active").find(">ul").slideUp(400);
            } else {
                $parent.siblings(".menu-item-has-children").removeClass("active").find("ul").slideUp(400);
                $parent.addClass("active").find(">ul").slideDown(400);
            }
        }
    });

    menuItemFirstLevel.hover(function () {
        $header.addClass('hovered');
    }, function () {
        $header.removeClass('hovered');
    });

    function stickyHeader() {
        let currentScroll = window.pageYOffset;
        if (currentScroll > 0) {
            $header.addClass('scrolled');
        } else {
            $header.removeClass('scrolled');
        }
    }

    function mobileMenu() {
        if (window.innerWidth < 1200 && body.hasClass("touch")) {
            $('.main-navigation-list > li.current-menu-ancestor.menu-item-has-children').addClass("active").find(">ul").slideDown(400);
        }
    }

    window.addEventListener("load", stickyHeader());
    window.addEventListener("load", mobileMenu());

    window.addEventListener("scroll", stickyHeader);
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerMenuAndSticky.js